import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Purchases = () => import('@/pages/Purchases')
const Purchase = () => import('@/pages/Purchase')

export default [
  {
    path: '/purchases',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Purchases',
        component: Purchases,
        meta: auth,
        props: route => ({
          page: (parseInt(route.query.page, 10) || 1)
        })
      },
      {
        path: ':id',
        name: 'Purchase',
        component: Purchase,
        meta: auth,
        props: route => ({
          id: parseInt(route.params.id, 10)
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/purchases.route.js